<template>
  <b-col>
    <b-row>
      <base-select-input
        v-model="data.value"
        :search-callback="userDataSearchCallback"
        :display-values="['fullName', 'firmname1']"
        :query-param="'userdata'"
        base-endpoint="userdata"
        @input="handleSelectItem($event)"
      ></base-select-input>
    </b-row>
  </b-col>
</template>
<script>

import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'idUserDataCustomField',
  components: { BaseSelectInput },
  props: {
    data: {}
  },
  data () {
    return {
      addPositionsFromCsvEnabled: false,
      addPositionsFromCsvSuccess: false,
      dataFile: ''
    }
  },
  methods: {
    async userDataSearchCallback (params = {}) {
      if (!this.data.idUserDataClientTypes || this.data.idUserDataClientTypes.length === 0) {
        return []
      }
      let baseParams = { pagination: false, state: 1, idClientType: this.data.idUserDataClientTypes }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items.map(entry => {
        entry['@id'] = getId(entry['@id'])
        return entry
      })
    },
    async handleSelectItem (id) {
      if (!id || id === 'null') {
        this.data.displayValue = ''
        this.$forceUpdate()
        return
      }
      id = getId(id)
      let item = await new ApiService(`user_datas/${id}`).getResults()
      if (item) {
        let text = ''
        const displayValues = ['fullName', 'firmname1']
        displayValues.forEach((property, index) => {
          if (property.includes('.')) {
            // https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
            let processedProperty = property.split('.').reduce((o, i) => o[i], item)
            text += processedProperty + (displayValues[index + 1] ? ' ' : '')
          } else {
            text += item[property] + (displayValues[index + 1] ? ' ' : '')
          }
        })
        this.data.displayValue = text
      }
      this.$forceUpdate()
    }
  }
}
</script>
